import { lazy } from "react";

export default [
	{
		path: "/archive",
		component: lazy(() => import("../../views/archive/")),
		exact: true,
	},
	{
		path: "/archive/add",
		component: lazy(() => import("../../views/archive/Add")),
		exact: true,
	},
	{
		path: "/archive/edit/:id",
		component: lazy(() => import("../../views/archive/Add")),
		exact: true,
	},
];
